import type { WritableDeep } from "type-fest";

export function isNotEmpty<T>(value: T | null | undefined): value is T {
  return value != null;
}

export function deepClone<T>(some_object: T): WritableDeep<T> {
  // eslint-disable-next-line unicorn/prefer-structured-clone
  return JSON.parse(JSON.stringify(some_object));
}
